import { render, staticRenderFns } from "./ControlAdministradores.vue?vue&type=template&id=d596eafe"
import script from "./ControlAdministradores.vue?vue&type=script&lang=js"
export * from "./ControlAdministradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports